import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateFamsAllocationPlanPayload,
  FamsAllocationPlan,
  UpdateFamsAllocationPlanPayload,
  UpdateFamsAllocationPlanStrategyPayload,
  FamsStrategyTargetItem,
} from './types/fams-allocation';

const request = createAppRequest();

export async function getFamsAllocationPlans(options?: ApiRequestOptions) {
  return request<FamsAllocationPlan[]>('/bff/fams/allocation-plans', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createFamsAllocationPlan(
  payload: CreateFamsAllocationPlanPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsAllocationPlan>('/bff/fams/allocation-plans', {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateFamsAllocationPlan(
  planCode: string,
  payload: UpdateFamsAllocationPlanPayload,
  options?: ApiRequestOptions,
) {
  return request<{ success: boolean }>(`/bff/fams/allocation-plans/${encodeURIComponent(planCode)}`, {
    method: 'PUT',
    data: payload,
    ...(options || {}),
  });
}

export async function deleteFamsAllocationPlan(planCode: string, options?: ApiRequestOptions) {
  return request<{ success: boolean }>(`/bff/fams/allocation-plans/${encodeURIComponent(planCode)}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function setDefaultFamsAllocationPlan(planCode: string, options?: ApiRequestOptions) {
  return request<{ success: boolean }>(
    `/bff/fams/allocation-plans/${encodeURIComponent(planCode)}/default`,
    {
      method: 'PUT',
      ...(options || {}),
    },
  );
}

export async function getFamsAllocationPlanStrategy(
  planCode: string,
  options?: ApiRequestOptions,
) {
  return request<FamsStrategyTargetItem[]>(
    `/bff/fams/allocation-plans/${encodeURIComponent(planCode)}/strategy`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

export async function updateFamsAllocationPlanStrategy(
  planCode: string,
  payload: UpdateFamsAllocationPlanStrategyPayload,
  options?: ApiRequestOptions,
) {
  return request<{ planCode: string; effectiveDate: string; version: string; count: number }>(
    `/bff/fams/allocation-plans/${encodeURIComponent(planCode)}/strategy`,
    {
      method: 'PUT',
      data: payload,
      ...(options || {}),
    },
  );
}
